import { render, staticRenderFns } from "./IconNextPage.vue?vue&type=template&id=86e0c5c0"
import script from "./IconNextPage.vue?vue&type=script&lang=js"
export * from "./IconNextPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports